
export const GET_VEG_DATA_REQUEST = "GET_VEG_DATA_REQUEST";
export const GET_VEG_DATA_SUCCESS = "GET_VEG_DATA_SUCCESS";
export const GET_VEG_DATA_FAILURE = "GET_VEG_DATA_FAILURE";

export const GET_DATA_REQUEST = "GET_DATA_REQUEST";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_FAILURE = "GET_DATA_FAILURE";

export const POST_DATA_REQUEST = "POST_DATA_REQUEST";
export const POST_DATA_SUCCESS = "POST_DATA_SUCCESS";
export const POST_DATA_FAILURE = "POST_DATA_FAILURE";

export const PATCH_DATA_REQUEST = "PATCH_DATA_REQUEST";
export const PATCH_DATA_SUCCESS = "PATCH_DATA_SUCCESS";
export const PATCH_DATA_FAILURE = "PATCH_DATA_FAILURE";

export const DELETE_DATA_REQUEST = "DELETE_DATA_REQUEST";
export const DELETE_DATA_SUCCESS = "DELETE_DATA_SUCCESS";
export const DELETE_DATA_FAILURE = "DELETE_DATA_FAILURE";

export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAILURE = "GET_CART_FAILURE";

export const PATCH_CART_REQUEST = "PATCH_CART_REQUEST";
export const PATCH_CART_SUCCESS = "PATCH_CART_SUCCESS";
export const PATCH_CART_FAILURE = "PATCH_CART_FAILURE";

export const POST_CART_REQUEST = "POST_CART_REQUEST";
export const POST_CART_SUCCESS = "POST_CART_SUCCESS";
export const POST_CART_FAILURE = "POST_CART_FAILURE";

export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST";
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS";
export const DELETE_CART_FAILURE = "GET_CART_FAILURE";


